import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { basicCustomMailSettingI18n } from "./query";

type Props = {
	hotelID: string;
	langCode: LangCode;
};

export const useFetchCustomMailSettingI18n = ({ hotelID, langCode }: Props) => {
	return useCustomSuspenseQuery(basicCustomMailSettingI18n, {
		variables: { hotelID, langCode },
		fetchPolicy: "no-cache",
		notifyOnNetworkStatusChange: true,
	});
};
